import React, { useEffect, useState } from 'react';
import { checkUserActiveStatus, makeSideBarActive } from '../../utils/EllowUtils';
import * as CONSTANTS from '../../utils/CONSTANTS';
import SideMenu from '../sideMenu';
import DashboardHeader from "../topbar";
import Tab from '../../components/tab';
import { TabStrip, TabStripSelectEventArguments } from '@progress/kendo-react-layout';
import Profile from './profile';
import ServicesOffering from './servicesOffering';
import AwardsCertifications from './awardsCertifications';
import PasswordChange from './passwordChange';
import Users from './users';
import { addNewCompanyUser, edituserStatus, getCustomerForUserId, getUserDetailsForCustomer, listUserDetailsForCustomer, updateCompanySettings, updateAwardsAndCertifications,  getProviderDomains} from './services';
import NotificationAlert from '../../components/notification';
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import { getAPI } from '../../api';

function CompanySettings() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);
  const BreadcrumsValues = ["Settings"];
  const [selected, setSelected] = useState<number>(0);
  const customerId = localStorage.getItem('customerId') || ''
  const [userlist, setUserList] = useState<any>()
  const [userDetails, setUserDetails] = useState<any>()
  const userLoginId = localStorage.getItem('loginId') || ''
  const [profileData, setProfileData] = useState<any>()
  const [defImage, setDefImage] = useState<string>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [companyName, setCompanyName] = useState<any>()
  const [awardsData , setAwardsData] = useState<any>([])
  const [certificationData , setCertificationData] = useState<any>([])
  const [servicesOfferingsValues , setServicesOfferingsValues] = useState<any>()
  const [disableProfileSaveButton , setDisableProfileSaveButton] = useState<boolean>(false)
  const [disableServiceButton , setDisableServiceButton] = useState<boolean>(false)
  const [providerDomains, setProviderDomains] = useState<any>()
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()
  const [customer_metadata, setCustomer_metadata] = useState<any>()

  useEffect(() => {
    
  getUsersList(customerId)
  getCompanyDetails(userLoginId)
  getProviderDomainsList()
    viewedpageMixpanel()
    
    getAPI('https://api.ellow.io/common/api/v1/ml/skills').then((value: any) => {
      if (value && value.status === 1) {
        setSkillList(value.data)
      }
    })

    getAPI('https://api.ellow.io/common//api/v1/ml/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })

  }, [customerId, userLoginId])
  
  const getCompanyDetails = (userLoginId: string) => {
    getCustomerForUserId(userLoginId).then((response) => {
      setProfileData(response.data[0])
      setDefImage(response.data[0].customer_metadata.image)
      setCompanyName(response.data[0].customer_metadata.companyName)
      setCustomer_metadata(response.data[0].customer_metadata)
      setServicesOfferingsValues(response.data[0].customer_metadata.servicesAndOfferings)
      setAwardsData(response.data[0].customer_metadata.awards && response.data[0].customer_metadata.awards  !== undefined ? response.data[0].customer_metadata.awards : [] )
      setCertificationData(response.data[0].customer_metadata.certifications && response.data[0].customer_metadata.certifications !== undefined ? response.data[0].customer_metadata.certifications  : [])
    })
  }

  const getProviderDomainsList = () => {
      
    getProviderDomains().then((response: any) => {
      if(response && response.status === 1){
        const list = response.data.map((item: any) => {
          return ({id: item.domain_id, name:item.domain_name})
        })       
        setProviderDomains(list)
      }
    }) 
  }

  const getUsersList = (customerId: string) => {
    listUserDetailsForCustomer(customerId).then((response) => {
     setUserList(response.data)
   })
 }


  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);    
  }
  
  const Back = () => {
    setSelected((prev) => prev - 1)
  }
 
  const getUserDetails = (user_id: string) => {
    getUserDetailsForCustomer(user_id).then((response) => {
      setUserDetails(response.data[0].user_metadata)
    })
  }
  
  const addNewUser = (data: any) => {

    addNewCompanyUser(data).then((response) => {

      if (response && response.status === 1) {
        mixpanelData('ML-New user added', {
          'source': 'New user added for the company',
          'FirstName': data.userMetadata && data.userMetadata.firstName,
          'LastName':data.userMetadata && data.userMetadata.lastName,
          'Email': data.userMetadata && data.userMetadata.email,
          'Phone': data.userMetadata && data.userMetadata.phone,
          'distinct_id': localStorage.getItem('Email')
        })
        getUsersList(customerId)
        setMessage('Details saved successfully')
        displayNotification()
        mixpanelData(`New ML - Company User ${data.userId ? 'edited' : 'added'}`, {
          'distinct_id': localStorage.getItem('Email'),
          'Company name': profileData && profileData.customer_metadata.companyName,
          "Name of the user": `${data && data.userMetadata && data.userMetadata.firstName} ${data && data.userMetadata && data.userMetadata.lastName}`,
          "Designation of the user":data && data.userMetadata && data.userMetadata.designation,
          "Email of the user": data && data.userMetadata && data.userMetadata.email,
          "Phone number": data && data.userMetadata && data.userMetadata.phone,
          'Company type': 'Provider',
          'Company id': customerId,
          'Primary': response && response.data[0].primary ? 'True' : 'False',
          "Status": response && response.data[0].activeStatus && checkUserActiveStatus(response.data[0].activeStatus)
        })
      }
    })
  }

  const checkAction = (action: string) => {
    switch (action) {
      case 'delete':
        return 'deleted';
      case 'primary':
        return 'changed to primary';
      case 'disable':
        return 'disabled';
      case 'enable':
        return 'enabled'
   }
 }

  const editUserStatus = (data: any) => {
   
    edituserStatus(data).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('ML-User status changed', {
          'source': `User's status changed to ${data.action}`,
          'distinct_id': localStorage.getItem('Email'),
          'CustomerId': data.customerId,
          'UserId': data.userId       
        })
        getUsersList(customerId)
        mixpanelData(`New ML -  user status changed to ${checkAction(data.action)}`, {
          'distinct_id': localStorage.getItem('Email'),
          "Company name": response && response.data.companyName,
          "Company type": response && response.data.userType,
          "Name of the user": response && response.data.userName,
          "Email of the user": response && response.data.userEmail,
          "Phone number ": response && response.data.phoneNumber,
          "Designation of the user": response && response.data.designation,
          "Primary": response && response.data.primary ? 'Yes' : 'No',
          "Status": response && response.data.activeStatus && checkUserActiveStatus(response.data.activeStatus),
          "Company id": customerId,
        })
      }
    })
  }

  const updateCompany = (data: any) => {  
    setDisableProfileSaveButton(true)
    let body =  {
      "customerId": customerId,
      "customerMetadata": {
      "size":data.size.id,      
      "website": data.website,
      "linkedinId": data.linkedinId,
      "profileUrl": data.profileUrl,
      "aboutCompany":data.description,
      "currencyType": data.currencyType,
      "roleDescription": data.roleDescription,
      'image':data.image,
      'googleLocations': data.googleLocations
      }
    }
    
    updateCompanySettings(body).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('ML-Company settings updated', {
          'source': 'User updates company settings',
          "size":data.size.name,      
          "website": data.website,
          "workWithRemote": data.workWithRemote,
          "linkedinId": data.linkedinId,
          "profileUrl": data.profileUrl,
          "aboutCompany":data.description,
          "currencyType": data.currencyType,
          "roleDescription": data.roleDescription,
          'distinct_id': localStorage.getItem('Email'),
          
        })
        getCompanyDetails(userLoginId)
        setMessage('Details saved successfully')
        setDisableProfileSaveButton(false)
        displayNotification()
        mixpanelData('New ML - Company profile updated', {
          'distinct_id': localStorage.getItem('Email'),
          'Profile link': data && data.profileUrl,
          'Linkedin': data && data.linkedinId,
          'Company website': data && data.website,
          'Company size': data && data.size.name,
          'Preferred currency': data && data.currencyType,
          'Locations': data.googleLocations && data.googleLocations.length > 0 && data.googleLocations.map((item: any) => item.name),
          'Company name': response && response.data[0].customer_metadata.companyName,
          'Company type': response && response.data[0].company_type === 1 ? 'Hirer' : response && response.data[0].company_type === 2 ? 'Provider' : 'Both',
          "Work with remote": data.workWithRemote === 1 ? 'NO' : 'YES',
          'Company id': customerId,
        })
      }
    })
  }

  const servicesOffering = (body: any) => {
    setDisableServiceButton(true)
    updateCompanySettings(body).then((response: any) => {
      if (response && response.status === 1) {
        mixpanelData('ML-Service offering updated', {
          'source': 'User updates service offering',
          'Domains': body && body.customerMetadata && body.customerMetadata.servicesAndOfferings && body.customerMetadata.servicesAndOfferings.domains && body.customerMetadata.servicesAndOfferings.domains.length > 0 && body.customerMetadata.servicesAndOfferings.domains.map((item: any) => item.name),
          'JobRoles': body && body.customerMetadata && body.customerMetadata.servicesAndOfferings && body.customerMetadata.servicesAndOfferings.jobRoles && body.customerMetadata.servicesAndOfferings.jobRoles.length > 0 && body.customerMetadata.servicesAndOfferings.jobRoles.map((item: any) => item.name),
          'Skills': body && body.customerMetadata && body.customerMetadata.servicesAndOfferings && body.customerMetadata.servicesAndOfferings.skills && body.customerMetadata.servicesAndOfferings.skills.length > 0 && body.customerMetadata.servicesAndOfferings.skills.map((item: any) => item.skillsName),
          'distinct_id': localStorage.getItem('Email')
        })
        getCompanyDetails(userLoginId)
        setMessage('Details saved successfully')
        mixpanelData('New ML - Service and Offerings updated', {
          'distinct_id': localStorage.getItem('Email'),
          'Company name': response && response.data[0].customer_metadata.companyName,
          'Type of company': response && response.data[0].company_type === 1 ? 'Hirer' : response && response.data[0].company_type === 2 ? 'Provider' : 'Both',
          'Status': 'Approved',
          'Services': body.customerMetadata && body.customerMetadata.servicesAndOfferings && body.customerMetadata.servicesAndOfferings.jobRoles && body.customerMetadata.servicesAndOfferings.jobRoles.length > 0 && body.customerMetadata.servicesAndOfferings.jobRoles.map((item: any) => item.name),
          'Domains': body.customerMetadata && body.customerMetadata.servicesAndOfferings && body.customerMetadata.servicesAndOfferings.domains && body.customerMetadata.servicesAndOfferings.domains.length > 0 && body.customerMetadata.servicesAndOfferings.domains.map((item:any) => item.name),
          'Technology capabilities': body.customerMetadata && body.customerMetadata.servicesAndOfferings && body.customerMetadata.servicesAndOfferings.skills && body.customerMetadata.servicesAndOfferings.skills.length > 0  && body.customerMetadata.servicesAndOfferings.skills.map((item: any) => item.skillName) ,
          'Company id': customerId,
        })
        setDisableServiceButton(false)
        displayNotification() 
      }
    })
  }

  const updateAwardCertifications = (data: any) => {
    updateAwardsAndCertifications(data).then((response) => {
      if (response && response.status === 1) {  
        getCompanyDetails(userLoginId)
        if(response.message === 'Certification Deleted Successfully'){    
          setMessage('Details deleted successfully')
          mixpanelData('ML-Awards and certifications deleted', {
            'source': ' users deleted awards and certifications',
            'Certification Name': data.customerMetadata && data.customerMetadata.certifications && data.customerMetadata.certifications.length > 0 && data.customerMetadata.certifications.map((item: any) => item.certificationName),
            'Certification Number': data.customerMetadata && data.customerMetadata.certifications && data.customerMetadata.certifications.length > 0 && data.customerMetadata.certifications.map((item: any) => item.certificationNumber),
            'distinct_id': localStorage.getItem('Email'),
            'section': data.section,

          })
          displayNotification()
        } else {  
          mixpanelData('ML-Awards and certifications updated', {
            'source': ' users updates awards and certifications',
            'Certification Name': data.customerMetadata && data.customerMetadata.certifications && data.customerMetadata.certifications.length > 0 && data.customerMetadata.certifications.map((item: any) => item.certificationName),
            'Certification Number': data.customerMetadata && data.customerMetadata.certifications && data.customerMetadata.certifications.length > 0 && data.customerMetadata.certifications.map((item: any) => item.certificationNumber),
            'section': data.section,
            'distinct_id': localStorage.getItem('Email')

          })
          setMessage('Details saved successfully')
          displayNotification()
          mixpanelData('New ML - Company awards and certifications updated', {
            'distinct_id': localStorage.getItem('Email'),
            'Company name': response && response.data[0].customer_metadata.companyName,
            'Type of company': response && response.data[0].customer_metadata.roleDescription,
            'Status': 'Approved',
            'Type' : data.section,
            'Certification/Award number': data.section === 'award' ? data.customerMetadata.awards[0].awardNumber : data.customerMetadata.certifications[0].certificationNumber,
            'Certification/Award name': data.section === 'award' ? data.customerMetadata.awards[0].awardName : data.customerMetadata.certifications[0].certificationName,
            'Company id': customerId,
          })
        }
      }
    })
  }

  const displayNotification = () => {
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }


  return (
      <section className="dashboardWrapper">
         {notification && <NotificationAlert onClose={onClose } closable={true} >
          {message}
          </NotificationAlert> }
        <SideMenu menu={menu} />
        <div className="dashboardContent">
          <DashboardHeader searchChange={undefined} title={BreadcrumsValues} />
          <div className="companySettingsTab">
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title="Profile">
                <Profile clickHandler={updateCompany} defaultValues={profileData} defImage={defImage} disable={disableProfileSaveButton}/>
              </Tab>
              <Tab title="Services & Offering">
              <ServicesOffering clickHandler={servicesOffering} customerId={customerId} defImage={defImage} companyName={companyName} defaultValues={servicesOfferingsValues} back={() => setSelected(0)} disable={disableServiceButton} providerDomains={providerDomains} skillsList={skillList} jobRolesList={jobRoleList} customer_metadata={customer_metadata}/>
              </Tab>
              <Tab title="Awards & Certifications">
                <AwardsCertifications customerId={customerId} defImage={defImage} companyName={companyName}  updateAwardCertifications={updateAwardCertifications} awardsData={awardsData} certificationData={certificationData}/>
              </Tab>
              <Tab title="Users">
                <Users back={Back} getUser={getUserDetails} addNewUser={addNewUser} companyName={companyName} defImage={defImage} editUserStatus={editUserStatus} usersList={userlist} defaultValues={userDetails} />
              </Tab>
              <Tab title="Change Password">
                <PasswordChange back={() => setSelected(0)} defImage={defImage} companyName={companyName} />
              </Tab>
            </TabStrip>
          </div>
        </div>
      </section> 
  )
}

export default CompanySettings;
